import types from "./types";

export const onList = () => ({
	type: types.EQUIPMENT_LIST_REQUESTED
});

export const onListSuccess = (payload) => ({
	type: types.EQUIPMENT_LIST_SUCCEEDED,
	payload
});

export const onListFailed = (payload) => ({
	type: types.EQUIPMENT_LIST_FAILED,
	payload
});

export const onAdd = (payload) => ({
	type: types.EQUIPMENT_CREATE_REQUESTED,
	payload
});

export const onAddSuccess = (payload) => ({
	type: types.EQUIPMENT_CREATE_SUCCEEDED,
	payload
});

export const onAddFailed = (payload) => ({
	type: types.EQUIPMENT_CREATE_FAILED,
	payload
});

export const onSave = (payload) => ({
	type: types.EQUIPMENT_UPDATE_REQUESTED,
	payload
});

export const onSaveSuccess = (payload) => ({
	type: types.EQUIPMENT_UPDATE_SUCCEEDED,
	payload
});

export const onSaveFailed = (payload) => ({
	type: types.EQUIPMENT_UPDATE_FAILED,
	payload
});

export const onRemove = (payload) => ({
	type: types.EQUIPMENT_DELETE_REQUESTED,
	payload
});

export const onRemoveSuccess = (payload) => ({
	type: types.EQUIPMENT_DELETE_SUCCEEDED,
	payload
});

export const onRemoveFailed = (payload) => ({
	type: types.EQUIPMENT_DELETE_FAILED,
	payload
});

